<div style="padding: 20px;background: #161616;">
    <h4 class="fc_DEDEDE">Are you sure to change the status of this project?</h4>
    <p class="fc_DEDEDE">Changing status will affect the project's visibility in CUSTOMER PORTAL and AGENT PORTAL.
        Please decide with cautions.</p>
    <div>
        <button mat-button (click)="changeStatus()"
            style="border:1px solid #dedede;color:#dedede;background:#161616">Confirm</button>
    </div>
</div>